export default __webpack_public_path__ + "img/18.asset.a49a25dc.jpeg";